import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

interface PrimaryBoxProps {
    children?: ReactNode;
}

const PrimaryBox: React.FC<PrimaryBoxProps> = ({ children }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                minWidth: 0,
                overflow: 'hidden',
                '@media (max-width: 900px)': {
                    overflow: 'auto',
                },
                '@media (max-height: 700px)': {
                    overflow: 'auto',
                },
            }}
        >
            {children}
        </Box>
    );
};

export default PrimaryBox;
